enum Constraints {
  BACKEND_MAX_PAGE_SIZE = 250
}

export default Constraints
